import { render, staticRenderFns } from "./PublicInfoRadioGroup.vue?vue&type=template&id=a2b50e3e&scoped=true&"
import script from "./PublicInfoRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./PublicInfoRadioGroup.vue?vue&type=script&lang=ts&"
import style0 from "./PublicInfoRadioGroup.vue?vue&type=style&index=0&id=a2b50e3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b50e3e",
  null
  
)

export default component.exports